import { motion } from "framer-motion";
import { TrendUp, TrendDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

// KPI card: large tabular value + optional trend. Space reserved for sparklines.
export function KpiCard({ label, value, delta, trend, hint, Icon, className, testId, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut", delay: index * 0.05 }}
      className={cn(
        "rounded-lg border border-border bg-card p-5 transition-colors hover:bg-accent/40",
        className,
      )}
      data-testid={testId}
    >
      <div className="flex items-center justify-between">
        <span className="promo-overline">{label}</span>
        {Icon && <Icon size={16} weight="duotone" className="text-muted-foreground" />}
      </div>
      <div className="mt-3 flex items-end gap-2">
        <span className="text-3xl font-medium tracking-tight tabular-nums leading-none">{value}</span>
        {delta != null && (
          <span
            className={cn(
              "flex items-center gap-0.5 text-xs font-medium tabular-nums",
              trend === "down" ? "text-destructive" : "text-success",
            )}
          >
            {trend === "down" ? <TrendDown size={12} weight="bold" /> : <TrendUp size={12} weight="bold" />}
            {delta}
          </span>
        )}
      </div>
      {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
    </motion.div>
  );
}
